import { usePage } from 'client/store'
import { getFirstEntityByType } from 'client/store/page/pageSelectors'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BodyInterface } from 'common/types/entities/body-interface'
import React from 'react'
import { Affiliate } from './components/affiliate'
import { Background } from './components/background'
import Tracking from './components/Tracking'
import { Typography } from './components/typography-new'
import LectureSettingsOld from './LectureSettings'

export const LectureSettingsResolver = () => {
  const isMigratedBodyEntity = usePage(page =>
    getFirstEntityByType(page, EntityTypeEnum.Body),
  )

  if (isMigratedBodyEntity) {
    return <LectureSettings />
  }
  return <LectureSettingsOld />
}

export const LectureSettings = () => {
  // @description: for Body
  return (
    <>
      <Typography skipFont />
      <Background<BodyInterface> />
      <Tracking />
      <Affiliate<BodyInterface> />
    </>
  )
}
